// The brand blue scale, fed to PrimeNG as its primary primitive by theme.ts.
//
// This used to live in tailwind.config.ts, whose own comment said Tailwind never loads it -- true
// (Tailwind 4 is CSS-first and src/styles.css does not `@config`), but it read as "this file is
// dead", and deleting it would have taken PrimeNG's accent colour with it. It is a palette module,
// so it lives here and is named for what it is.
//
// Keep identical to the --color-blue-* values in src/styles.css, which is what actually generates
// the Tailwind `*-blue-*` utilities. If the two drift, PrimeNG accents and Tailwind utilities
// render different blues.
//
// Only `blue` is overridden, so the rest of Tailwind's default palette (red-*, green-*, ...)
// survives. homey-admin-app replaced theme.colors wholesale with just this scale, which silently
// broke every red-*/green-* utility in its templates -- do not repeat that here.
const blue = {
  50: '#eff6ff',
  100: '#dbeafe',
  200: '#bfdbfe',
  300: '#93c5fd',
  400: '#60a5fa',
  500: '#376ef7',
  600: '#2563eb',
  700: '#1d4ed8',
  800: '#1e40af',
  900: '#1e3a8a',
  950: '#172554',
} as const;

export const colors = {
  blue,
} as const;
